import flexslider from '../../js/jquery.flexslider-min.js?raw';
import {injectLegacyScript} from './inject-legacy-script';

export function ensureFlexsliderPlugin()
{
    if (!window.jQuery || window.jQuery.fn.flexslider) {
        return;
    }

    injectLegacyScript(flexslider);
}

export function initTestimonialSlider(selector)
{
    if (!window.jQuery) {
        return;
    }

    var $ = window.jQuery;

    $(window).on('load', function () {
        var $slider = $(selector || '.testimonialSlider');

        if (!$slider.length || !$.fn.bxSlider) {
            return;
        }

        $slider.bxSlider({
            mode: 'fade',
            captions: true,
        });
    });
}

export function initSimpleSlider(selector, options)
{
    if (!window.jQuery) {
        return;
    }

    ensureFlexsliderPlugin();

    var $ = window.jQuery;
    var settings = options || {};

    $(window).on('load', function () {
        var $slider = $(selector || '#flexslider-18');

        if (!$slider.length || !$.fn.flexslider) {
            $('body').removeClass('loading');
            return;
        }

        $slider.flexslider(Object.assign({
            animation: 'fade',
            animationLoop: true,
            itemMargin: 0,
            easing: 'swing',
            direction: 'horizontal',
            reverse: false,
            smoothHeight: false,
            startAt: 0,
            slideshow: true,
            slideshowSpeed: 7000,
            animationSpeed: 600,
            initDelay: 0,
            randomize: false,

            pauseOnAction: true,
            pauseOnHover: false,
            useCSS: true,
            touch: true,
            video: false,

            controlNav: true,
            directionNav: true,
            prevText: 'Previous',
            nextText: 'Next',

            keyboard: true,
            multipleKeyboard: false,
            mousewheel: false,
            pausePlay: false,
            pauseText: 'Pause',
            playText: 'Play',

            controlsContainer: '',
            manualControls: '',
            sync: '',
            asNavFor: '',

            itemWidth: 0,
            minItems: 0,
            maxItems: 0,
            move: 0,

            carousel: false,
            start: function (slider) {
                $('body').removeClass('loading');
                $('.slide-current-slide').text(slider.currentSlide + 1);
                $('.slide-total-slides').text(' / ' + slider.count);
            },
            before: function (slider) {
                $('.slide-current-slide').text(slider.animatingTo + 1);
            },
        }, settings));
    });
}
